import { Link } from "react-router-dom";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LoginAuthContext } from "Context/Authentication/LoginAuth";
import logo from "assests/logos/dclass.png";
import logoAr from "assests/logos/arabic-dclass-logo.png";

const Logo = ({ className = "w-32", onClick }) => {
  const { isAuthenticated } = useContext(LoginAuthContext);
  const { i18n } = useTranslation();
  const to = isAuthenticated ? "/categories" : "/";
  const isRTL = i18n.language === "ar";

  return (
    <Link to={to} onClick={onClick}>
      <img
        className={className}
        src={isRTL ? logoAr : logo}
        alt="D-Class"
      />
    </Link>
  );
};

export default Logo;
